import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageService } from '../../service/managers/storage.service';

import { Config } from '../component_dependent/config';

@Injectable({
  providedIn: 'root'
})
export class DropdownService extends Config {

  constructor(private httpClient: HttpClient, private storageService: StorageService) {
    super();
  }

  public getBatchDetailDropdown(){
     var url ="get_batch_detail_dropdown"
     return this.httpClient.get(this.BASE_URL + url,this.storageService.getHeaders())
  }
  
  // public getCallType(){
  //   var url = "get_call_type"
  //   return this.httpClient.get(this.BASE_URL + url,this.storageService.getHeaders())
  // }
  
  // public getBatchType(){
  //   var url = "get_batch_type"
  //   return this.httpClient.get(this.BASE_URL + url,this.storageService.getHeaders())
  // }


}
